import { TagDto } from '../../tags/dtos/tag.dto';
import { ReportTemplateTypeEnum } from '../enums/report-template-type.enum';

/**
 * Create report template DTO
 */
export class CreateReportTemplateDto {
	name!: string;
	path!: string;
	description?: string;
	notes?: string;
	type!: ReportTemplateTypeEnum;
	body?: string;
	tags?: TagDto[];
}
